import WHITE_LIST from 'constants/whitelist'

export const isInWhitelist = (account, label) => {
  const addr = account.toLowerCase()
  // console.log(`WHITE_LIST`, WHITE_LIST)
  // console.log(`addr`, addr)

  return WHITE_LIST[addr] && WHITE_LIST[addr][label.trim()] ? true : false
}

export const isAvailable = (account, label, state) => {
  let available = false

  // console.group('is availabel')
  // console.log(`account`, account)
  // console.log(`label`, label)
  // console.log(`state`, state)
  // console.groupEnd()
  // 0 => Unknown
  // 1 => Invalid Name
  // 2 => In Whitelist
  // 3 => In Reservation
  // 4 => Not Available Name
  // 5 => Available

  if (state === 5) {
    available = true
  }
  // else if (state === 2 || state === 4) {
  //   // in whitelist
  //   console.log(isInWhitelist(account, label))
  //   available = isInWhitelist(account, label)
  // }
  // console.log(`available`, available)

  return available
}
